var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
/* eslint-disable react/function-component-definition */
import { useRef, useState } from 'react';
import styled from 'styled-components';
import * as Yup from 'yup';
import { ErrorMessage, Form, Formik } from 'formik';
import { useNavigate } from 'react-router';
import Button from '@mui/material/Button';
import BackIcon from '@mui/icons-material/ArrowBack';
import { TextField } from '@mui/material';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import { useQuery } from '../../hooks';
import * as matches from '../../api/matches';
import { Alerts } from '../../components/molecules/Alerts/Alerts';
import { PageWrapperNew } from '../../components/atoms/PageWrapper';
import { Delimiter } from '../../components/atoms/Delimiter';
import { useErrorHandler } from '../../hooks/useErrorHandler';
import { DataContainerNew } from '../../components/atoms/DataContainer';
const commonStyles = {
    wrap: 'nowrap',
    display: 'flex',
    flexDirection: 'column',
    padding: '10px',
    width: '30%',
    margin: '0 auto',
};
const titleStyle = {
    wrap: 'nowrap',
    width: '30%',
    margin: '0 auto',
    boxShadow: 'none',
    background: 'transparent',
};
const HeaderContainer = styled.div `
  display: flex;
  justify-content: space-between;
  align-items: center;
`;
const AdditionalGameContainer = styled.div `
  display: flex;
  cursor: pointer;
  width: max-content;
  align-items: center;
  user-select: none;
`;
const AdditionalGameText = styled.div `
  transition: 0.3s;
  font-weight: 500;
  font-size: 14px;
  line-height: 20px;
  color: ${({ checked }) => (checked ? '#FFD643' : '#FFFFFF')};
`;
const SherifImg = styled.img `
  width: 397px;
  height: 295px;
  position: absolute;
  top: 61px;
  left: -20px;
`;
const FormContainer = styled.div `
  width: 100%;
  position: relative;
  background: rgba(255, 255, 255, 0.1);
  border: 4px solid #ffffff;
  backdrop-filter: blur(14px);
  border-radius: 24px;
  padding: 54px 67px 72px 74px;
`;
const InputContainer = styled.div `
  display: flex;
  flex-direction: column;
  width: max-content;
  margin-left: auto;
`;
const InputLabel = styled.div `
  font-style: normal;
  font-weight: 700;
  font-size: 12px;
  line-height: 20px;
  color: #212121;
`;
const PasswordWithInfo = styled.div `
  display: flex;
  align-items: center;
`;
const InputInfo = styled.div `
  width: 270px;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: rgba(0, 0, 0, 0.8);
`;
// const Input = styled(Field)`
//   width: 267px;
//   height: 44px;
//   padding: 12px 20px;
//   background: #517573;
//   border: 1px solid #ffffff;
//   border-radius: 47px;
//   font-weight: 400;
//   font-size: 14px;
//   line-height: 20px;
//   color: #ffffff;
//   outline: none;
//
//   &::placeholder {
//     color: rgba(255, 255, 255, 0.7);
//   }
//
//   &:-webkit-autofill {
//     transition: background-color 50000s ease-in-out 0s;
//     -webkit-text-fill-color: #ffffff !important;
//   }
//
//   &:active,
//   &:focus {
//     outline: none;
//   }
// `
const Error = styled.span `
  color: red;
  z-index: 100;
`;
const requiredFieldError = 'Это поле необходимо заполнить';
const validationSchema = Yup.object().shape({
    password: Yup.string().required(requiredFieldError),
});
export const CreateMatch = () => {
    const [additionalGame, setAdditonalGame] = useState(false);
    const createMatchRef = useRef();
    const nav = useNavigate();
    // const eventId = useAppSelector(selectEventId)
    const { param: eventId } = useQuery('eventId');
    const { errorHandler } = useErrorHandler();
    const renderError = (message) => _jsx(Error, { children: message });
    const initialValues = {
        password: Math.floor(1000 + Math.random() * 9000).toString(),
    };
    const createMatch = (data) => __awaiter(void 0, void 0, void 0, function* () {
        var _a, _b;
        if (!eventId)
            return;
        try {
            const createMatchData = {
                eventId,
                password: data.password,
            };
            const result = yield matches.createMatch(createMatchData);
            // console.log('CreateMatch createMatch', result)
            nav(`/match-config?matchId=${result.id}`);
        }
        catch (e) {
            console.error('Matches createMatch error', e);
            createMatchRef.current.setFieldError('password', (_b = (_a = e.response) === null || _a === void 0 ? void 0 : _a.data) === null || _b === void 0 ? void 0 : _b.password[0]);
            errorHandler(e);
        }
    });
    const onSubmit = (data) => {
        // console.log('CreateMatch submit', data)
        createMatch(data);
    };
    const onClickAdditionalGame = () => {
        setAdditonalGame(!additionalGame);
    };
    return (_jsx(DataContainerNew, { children: _jsxs(PageWrapperNew, { children: [_jsx(Alerts, {}), _jsx(Button, { sx: { width: 120 }, startIcon: _jsx(BackIcon, {}), onClick: () => nav(`/matches?eventId=${eventId}`) }), _jsx(Delimiter, { top: "49px" }), _jsx(Paper, Object.assign({ sx: titleStyle }, { children: _jsx(Typography, Object.assign({ variant: "h2" }, { children: "\u0421\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0438\u0433\u0440\u044B" })) })), _jsx(Delimiter, { top: "70px" }), _jsx(Formik, Object.assign({ innerRef: createMatchRef, initialValues: initialValues, validationSchema: validationSchema, onSubmit: onSubmit }, { children: ({ values, setFieldValue }) => (_jsx(Form, { children: _jsxs(Paper, Object.assign({ sx: commonStyles }, { children: [_jsx(Typography, Object.assign({ variant: "subtitle1" }, { children: "\u0421 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u0430\u0440\u043E\u043B\u044F \u0438\u0433\u0440\u043E\u043A\u0438 \u0441\u043C\u043E\u0433\u0443\u0442 \u0441\u0430\u043C\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0432\u043E\u0439\u0442\u0438 \u0432 \u0438\u0433\u0440\u0443 \u0447\u0435\u0440\u0435\u0437 \u0431\u043E\u0442" })), _jsx(Delimiter, { top: "20px" }), _jsx(TextField, { onChange: (event) => setFieldValue('password', event.target.value), value: values.password, name: "password", size: "medium", placeholder: "Type in here\u2026", variant: "outlined" }), _jsx(Delimiter, { top: "10px" }), _jsx(ErrorMessage, { name: "password", render: renderError }), _jsx(Delimiter, { top: "10px" }), _jsx(FormControlLabel, { onClick: onClickAdditionalGame, control: _jsx(Checkbox, { checked: additionalGame }), label: "\u0414\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0438\u0433\u0440\u0430" }), _jsx(Delimiter, { top: "20px" }), _jsx(Button, Object.assign({ variant: "contained", size: "large", type: "submit" }, { children: "\u0421\u043E\u0437\u0434\u0430\u0442\u044C \u0438\u0433\u0440\u0443" }))] })) })) }))] }) }));
};
